import React, {Component} from 'react';
import {Grid} from '@material-ui/core';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import KeyValueList from 'components/key-value-list';
import Button from 'components/button';
import styles from './styles.less';

export default class MenuProfile extends Component {
    static propTypes = {
        user: PropTypes.object.isRequired,
        visible: PropTypes.bool.isRequired,
    }

    render() {
        const {user, visible} = this.props;
        return (
            <div className={classNames(styles.root, {[styles.show]: visible})}>
                <Grid direction='column' container spacing={2} className={styles.dataContainer}>
                    <Grid item>
                        <p className={styles.title}>Datos del usuario</p>
                    </Grid>
                    <Grid item>
                        <KeyValueList
                            column
                            data={user}
                            rows={[
                                {key: 'firstName', label: 'Nombre'},
                                {key: 'lastName', label: 'Apellido'},
                                {key: 'email', label: 'Email'},
                                {key: 'category.name', label: 'Tipo de usuario'},
                                {label: 'Notificaciones', value: user.receiveOrganizationEmails ? 'Sí' : 'No'},
                            ]}
                        />
                    </Grid>
                </Grid>
                <Grid direction='column' container spacing={2} className={styles.dataContainer}>
                    <Grid item>
                        <p className={styles.title}>Datos de la organización</p>
                    </Grid>
                    <Grid item>
                        <KeyValueList
                            column
                            data={user.organization}
                            rows={[
                                {key: 'name', label: 'Nombre'},
                                {key: 'legalName', label: 'Razón social'},
                                {key: 'cuit', label: 'CUIT'},
                                (user.organization.region && {key: 'region.name', label: 'Región Nidera'}),
                            ]}
                        />
                    </Grid>
                </Grid>
                <Grid justify='center' container spacing={2} className={styles.buttonContainer}>
                    <Grid item xs={5}>
                        <a target='_blank' href={`${window.SSO_UI_URL}/profile`}>
                            <Button theme='yellow'>
                                EDITAR PERFIL
                            </Button>
                        </a>
                    </Grid>
                    <Grid item xs={5}>
                        <a target='_blank' href={`${window.SSO_UI_URL}/password/change`}>
                            <Button theme='yellow'>
                                CAMBIAR CONTRASEÑA
                            </Button>
                        </a>
                    </Grid>
                </Grid>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./components/header/menu-profile/index.js